export const FeatureGroups = {
  CAP_FEATURES_GROUP: 'capFeatures',
  CUSTOM_FEATURES_GROUP: 'customFeatures',
};
